import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Stack } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { spacing } from '@mui/system';
import { shouldNotForwardProps, spacing as spacing$1, withUtility } from '../../foundation/utils.js';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11;
const FeedbackBannerStyled = styled(Stack, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};

  padding: ${0};

  ${0}

  ${0};

  ${0};
`), spacing, spacing$1(4), withUtility(({}, {
  fullWidth
}) => {
  if (!fullWidth) {
    return;
  }
  return css(_t2 || (_t2 = _`
      width: 100%;
    `));
}), withUtility(({
  palette
}, {
  divider
}) => {
  switch (true) {
    case divider === 'top':
      return css(_t3 || (_t3 = _`
          background-color: ${0};
          border-top: 1.5px solid;
          color: ${0};
          border-radius: 0;
        `), palette('surfaceAt1'), palette('onSurface'));
    case divider === 'bottom':
      return css(_t4 || (_t4 = _`
          background-color: ${0};
          border-bottom: 1.5px solid;
          color: ${0};
          border-radius: 0;
        `), palette('successContainer'), palette('onSuccessContainer'));
    default:
      return css(_t5 || (_t5 = _`
          border: 1.5px solid;
          border-radius: 12px;
        `));
  }
}), withUtility(({
  palette
}, {
  variant
}) => {
  switch (true) {
    case variant === 'neutral':
      return css(_t6 || (_t6 = _`
          background-color: ${0};
          border-color: ${0};
          color: ${0};
        `), palette('surfaceAt1'), palette('surfaceVariant'), palette('onSurface'));
    case variant === 'positive':
      return css(_t7 || (_t7 = _`
          background-color: ${0};
          border-color: ${0};
          color: ${0};
        `), palette('successContainer'), palette('onSuccessContainer'), palette('onSuccessContainer'));
    case variant === 'attention':
      return css(_t8 || (_t8 = _`
          background-color: ${0};
          border-color: ${0};
          color: ${0};
        `), palette('warningContainer'), palette('onWarningContainer'), palette('onWarningContainer'));
    case variant === 'negative':
      return css(_t9 || (_t9 = _`
          background-color: ${0};
          border-color: ${0};
          color: ${0};
        `), palette('errorContainer'), palette('onErrorContainer'), palette('onErrorContainer'));
    case variant === 'informative':
      return css(_t10 || (_t10 = _`
          background-color: ${0};
          border-color: ${0};
          color: ${0};
        `), palette('infoContainer'), palette('onInfoContainer'), palette('onInfoContainer'));
    default:
      return css(_t11 || (_t11 = _``));
  }
}));
const FeedbackBanner = _a => {
  var {
      children,
      icon,
      action,
      secondaryAction,
      variant = 'neutral',
      divider
    } = _a,
    props = __rest(_a, ["children", "icon", "action", "secondaryAction", "variant", "divider"]);
  const getIcon = () => {
    if (icon === false) {
      return null;
    } else if (icon === undefined) {
      switch (variant) {
        case 'positive':
          return jsx(CheckCircleOutlineIcon, {});
        case 'attention':
          return jsx(WarningAmberIcon, {});
        case 'negative':
          return jsx(ErrorOutlineOutlinedIcon, {});
        case 'informative':
          return jsx(InfoOutlinedIcon, {});
      }
    }
    return icon;
  };
  return jsx(FeedbackBannerStyled, Object.assign({}, props, {
    variant: variant,
    divider: divider
  }, {
    children: jsxs(Stack, Object.assign({
      direction: "column",
      spacing: 3
    }, {
      children: [jsxs(Stack, Object.assign({
        direction: "row",
        spacing: 2
      }, {
        children: [getIcon(), jsx("div", {
          children: children
        })]
      })), (action || secondaryAction) && jsxs(Stack, Object.assign({
        direction: "row",
        spacing: 3,
        alignSelf: "end"
      }, {
        children: [secondaryAction, action]
      }))]
    }))
  }));
};

export { FeedbackBanner };
